<template>
  <!-- eslint-disable vue/no-v-html -->
  <v-sheet
    width="100%"
    max-width="900"
    min-width="360"
    elevation="10"
    :tile="true"
    class="mx-auto my-5"
  >
    <!-- Draft warning -->
    <div
      v-if="mode.includes('Draft')"
      class="draftWarn brandFont"
    >
      Unpublished profile
    </div>

    <!-- Section 1 - Coach main information -->
    <Section1
      :coach="coach"
      :loading="loading"
    />

    <!-- Section 2 - Coach location, language information -->
    <Section2
      v-if="showSection2"
      :coach="coach"
      :loading="loading"
    />

    <!-- Section Sub information - Coach company, email -->
    <SectionSubInfo
      v-if="showSectionSubInfo"
      :coach="coach"
      :loading="loading"
    />

    <!-- Section 3 - Bio -->
    <Section3
      v-if="showSection3"
      :coach="coach"
      :loading="loading"
    />

    <!-- Section 4 - Experience HTML -->
    <Section4
      v-if="showSection4"
      :coach="coach"
      :loading="loading"
    />

    <!-- Section 5 - Qualification -->
    <Section5
      v-if="showSection5"
      :coach="coach"
      :loading="loading"
    />

    <!-- Section 6 - Accreditations -->
    <Section6
      :coach="coach"
      :loading="loading"
    />

    <!-- Footer -->
    <v-footer
      color="primary"
      dark
    >
      <span class="brandFont caption mx-auto">
        Copyright © {{ new Date().getFullYear() }} Global Coach Group | All Rights Reserved.
      </span>
    </v-footer>
  </v-sheet>
</template>

<script>
import coachApi from '@/api/coach';

// Section components
import Section1 from './profile-widget/Section1.vue';
import Section2 from './profile-widget/Section2.vue';
import SectionSubInfo from './profile-widget/SectionSubInfo.vue';
import Section3 from './profile-widget/Section3.vue';
import Section4 from './profile-widget/Section4.vue';
import Section5 from './profile-widget/Section5.vue';
import Section6 from './profile-widget/Section6.vue';

export default {
  name: 'CoachProfile',

  components: {
    Section1,
    Section2,
    SectionSubInfo,
    Section3,
    Section4,
    Section5,
    Section6,
  },

  props: {
    mode: {
      type: String,
      default: 'coachProfile',
    },
  },

  data: () => ({
    coach: {
      profile: {},
    },
    loading: false,
  }),

  computed: {
    showSection2() {
      return Object.entries(this.coach.profile).length;
    },

    showSectionSubInfo() {
      return this.mode !== 'gcgCoachProfile'
        && Object.entries(this.coach.profile).length
        && (this.coach.profile.linkedin_url
          || this.coach.profile.company.email
          || this.coach.profile.company.telephone
          || this.coach.profile.company.website
        );
    },

    showSection3() {
      return Object.entries(this.coach.profile).length && this.coach.profile.bio;
    },

    showSection4() {
      return Object.entries(this.coach.profile).length && this.coach.profile.experience;
    },

    showSection5() {
      return Object.entries(this.coach.profile).length
        && (this.coach.profile.qualifications || this.coach.profile.accreditations);
    },
  },

  created() {
    this.getCoach();
  },

  methods: {
    async getCoach() {
      try {
        this.loading = true;

        switch (this.mode) {
          case 'coachProfile':
          case 'gcgCoachProfile':
            // By Url index
            this.coach = await coachApi.getByUrlIndex(this.$route.params.url_index);
            break;
          case 'coachProfileByID':
            // By id
            this.coach = await coachApi.getById(this.$route.params.id);
            break;
          case 'coachProfileDraftCoach':
            // Draft for coach
            this.coach = await coachApi.getDraftCoachProfile();
            break;
          case 'coachProfileDraft':
            // Draft for mam
            this.coach = await coachApi.getDraftByCoachId(this.$route.params.coach_id);
            break;
          default:
            break;
        }

        if (!this.coach.profile) this.coach.profile = {};
        document.title = `${this.coach.first_name} ${this.coach.last_name}'s profile`;
      } catch (error) {
        console.log(error);
        this.$router.push({ name: 404 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css?family=Montserrat:500,500i,700&display=swap');

  .draftWarn {
    width: 100%;
    max-width: 900px;
    margin: auto;
    background-color: red;
    color: white;
    font-weight: bold;
    text-align: center;
    padding: 3px;
  }

  .top {
    .intro {
      background-color: rgba(0, 17, 25, 0.48);
      white-space: pre-line;
    }

    .v-skeleton-loader__avatar {
      height: 175px;
      width: 175px;
    }
  }
</style>

<style lang="scss">
  @import '~quill/dist/quill.snow.css';

  .brandFont {
    font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    &.fiveHundred {
      font-weight: 500;
    }
  }

  #coachProfileAvatar .v-skeleton-loader__avatar {
    height: 175px;
    width: 175px;
  }
</style>
